import { Button, DatePicker,Form, Grid, Input, Select, Space  } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useGetRoleTypes } from 'features/users/use-cases/get-roleTypeList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UpLoadingFilterFormField, UpLoadingFilterFormValues } from './type';
const { RangePicker } = DatePicker;


const { useBreakpoint } = Grid;

type VehicleFilterFormProps = {
  formId: string;
  handleFilter: (values: UpLoadingFilterFormValues) => void;
  initialValues: UpLoadingFilterFormValues;
  closeModal?: () => void;
  onRefresh: () => void;
};

export const UpLoadingFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
  onRefresh
}: VehicleFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<UpLoadingFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const { data: roleTypeFilterList, isLoading: roleTypeFilterLoading } = useGetRoleTypes();
  // const onReset = () => {
  //   form.resetFields();
  //   handleFilter(initialValues);
  //   onRefresh();
  // };
  const onReset = () => {
  form.setFieldsValue({
    MaterialName: undefined,
    DriverName: undefined,
    VehicleNumber: undefined,
    Status: undefined,
    date:undefined
  });

  handleFilter({} as any); // send empty filter to parent / API
  onRefresh();
};

  const onFinish = (formValues: UpLoadingFilterFormValues) => {
    handleFilter(formValues);
    closeModal?.();
  };
  if (roleTypeFilterLoading) return null;

  if (!roleTypeFilterList || !Array.isArray(roleTypeFilterList) || roleTypeFilterList.length === 0) {
    return <div>No roles available</div>;
  }


  return (
    <Form<UpLoadingFilterFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper className='cf_frm' style={{ width: '100%' }}>
        <StandardItemsWrapper className='cf_frm_row' style={{ width: '100%' }}>
          <div className='invoice_list' style={{ width: '100%' }}>
            <Form.Item<UpLoadingFilterFormValues>
              label={'Material Name	'}
              name={UpLoadingFilterFormField.MaterialName}
            >
              <Input
                placeholder={'Enter Material Name'}
              />
            </Form.Item>
            <Form.Item<UpLoadingFilterFormValues>
              label={'Driver Name'}
              name={UpLoadingFilterFormField.DriverName}
            >
              <Input
                placeholder={'Enter Driver Name'}
              />
            </Form.Item>
            <Form.Item<UpLoadingFilterFormValues>
              label={'Vehicle Number '}
              name={UpLoadingFilterFormField.VehicleNumber}
            >
              <Input
                placeholder={'Enter Vehicle Number'}
              />
            </Form.Item>
            <Form.Item<UpLoadingFilterFormValues>
              label={'Unloading Date'}
              name={UpLoadingFilterFormField.Date}
            >
              <RangePicker />
            </Form.Item>
            <Form.Item<UpLoadingFilterFormValues>
              label="Status"
              name={UpLoadingFilterFormField.Status}
            >
              <Select
                placeholder="Select status"
                style={{ width: 220 }}
                options={[
                  { label: "Not Requested", value: 0 },
                  { label: "Approved", value: 1 },
                  { label: "Pending", value: 2 },
                  { label: "Rejected", value: 3 },
                ]}
              />
            </Form.Item>

            {screens.lg && (
              <Space>
              <ContentFilters.ButtonsWrapper className='filter_btn'>
                <Button type='primary' htmlType='submit' >
                  {t('common.buttons.filter', { count: 1 })}
                </Button>
                <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
              </ContentFilters.ButtonsWrapper>
              </Space>
            )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>


    </Form>
  );
};
